<template>
  <v-container fluid class="pa-0" style="height: inherit; background-color: white;" v-if="!loading && Machine">
    <v-row no-gutters align="stretch" style="height: inherit;">
      <v-col>
        <EntityEditCard :title="$t('servicesystem.common_objects.customer.customer')" :item="Machine"
          :saveMethod="saveChanges" class="mb-3">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <MachineCustomerEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
            </MachineCustomerEditContent>
          </template>
        </EntityEditCard>

        <v-divider></v-divider>

        <template v-if="unitEnabled">
          <EntityEditCard :title="$t('servicesystem.common_objects.unit.unit')" :item="Machine"
            :saveMethod="saveChanges" class="mb-3">
            <template v-slot:content="{ item, editMode, handleFocus }">
              <MachineUnitEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
              </MachineUnitEditContent>
            </template>
          </EntityEditCard>

          <v-divider></v-divider>
        </template>

        <EntityEditCard :title="$t('servicesystem.common_objects.machine.product')" :item="Machine"
          :saveMethod="saveChanges" class="mb-3">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <MachineProductEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
            </MachineProductEditContent>
          </template>
        </EntityEditCard>

        <v-divider></v-divider>

        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="Machine"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <MachineDetailsEditContent :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
            </MachineDetailsEditContent>
          </template>
        </EntityEditCard>
      </v-col>

      <v-divider vertical style="z-index: 5;" />

      <v-col style="background-color: rgb(248, 248, 248) !important;">
        <v-card class="ma-3">
          <machine-contract-card :machineId="Machine.Id">
          </machine-contract-card>
        </v-card>
        <v-card v-if="preventiveMaintenanceEnabled" class="ma-3">
          <machine-forecasting-card :Machine="Machine">
          </machine-forecasting-card>
        </v-card>
        <v-card class="ma-3">
          <performance-card :id="Machine.Id">
          </performance-card>
        </v-card>
        <v-card class="ma-3">
          <SlottedCard :title="$t('servicesystem.common_objects.machine.machine_counters')" :icon="'mdi-counter'"
            :fontsize="'h4'">
            <template v-slot:content>
              <MachineCountersCardContent :machineId="machineId">
              </MachineCountersCardContent>
            </template>
          </SlottedCard>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineCustomerEditContent from "@/views/admin/machines/MachineCustomerEditContent.vue";
import MachineUnitEditContent from "@/views/admin/machines/MachineUnitEditContent.vue";
import MachineDetailsEditContent from "@/views/admin/machines/MachineDetailsEditContent.vue";
import MachineProductEditContent from "@/views/admin/machines/MachineProductEditContent.vue";
import MachineContractCard from "@/views/job/newjob/cards/machines/MachineContractCard.vue";
import MachineCountersCardContent from "@/views/job/newjob/cards/machines/MachineCountersCardContent.vue";
import MachineForecastingCard from "@/views/job/newjob/cards/machines/MachineForecastingCard.vue";
import PerformanceCard from "@/views/job/newjob/cards/machines/PerformanceCard.vue";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "ViewMachineInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    MachineDetailsEditContent,
    MachineProductEditContent,
    MachineUnitEditContent,
    MachineCustomerEditContent,
    PerformanceCard,
    MachineContractCard,
    MachineCountersCardContent,
    MachineForecastingCard,
    SlottedCard,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  methods: {
    async saveChanges(obj) {
      //this.loading = true;
      const dto = Object.assign(obj);

      await clientAPI.methods.changeMachine(dto)
        .then((response) => {
          this.Machine = Object.assign({}, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          //this.loading = false;
        });
    },
  },

  computed: {
    Machine: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

    machineId() {
      return this.$route.params.machineId;
    },

    loading() {
      return this.containerLoading;
    },

    unitEnabled() {
      return this.$store.state.GlobalSettings.Features.UnitEnabled;
    },

    preventiveMaintenanceEnabled() {
      return this.$store.state.GlobalSettings.PreventiveMaintenanceEnabled;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
.uplifted {
  z-index: 10;
}
</style>